import React, { Component } from 'react';
import SchemaForm from './SchemaForm';

import schema from './schemas/upgrade.json';
const uiSchema = {
  name: {
    'ui:autofocus': true,
  },
  text: {
    'ui:widget': 'textarea',
  },
  ability: {
    'ui:widget': 'textarea',
  },
};

class UpgradeForm extends Component {
  render() {
    return <SchemaForm schema={schema} uiSchema={uiSchema} {...this.props} />;
  }
}

export default UpgradeForm;



// WEBPACK FOOTER //
// ./src/UpgradeForm.js